import { InternalContactsList } from './InternalContactsList';

export const InternalContactsListVendor = () => <InternalContactsList onSave={async () => null} showSearch readOnly />;
